module.exports = __webpack_public_path__ + "static/05.0fbf7fc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/05.png
// module id = 442
// module chunks = 35783957827783 172322841747965